<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <v-card>
      <v-card-title>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class=" mr-2" @click="doNew">
          New Cover Letter
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
      </v-card-title>
      <v-flex xs12>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            item-key="name"
            :loading="loading"
            :no-data-text="noDataText"
            :custom-filter="customSearch"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.scheme }}</td>
                <td class="text-xs-left">{{ row.item.letterType }}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    review
                    @review="doReview(row.item)"
                    query
                    @query="doQuery(row.item)"
                    remove
                    @remove="doPromptRemove(row.item)"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-card>
    <v-dialog v-model="coverLetterReview" width="800px" persistent>
      <v-card
        ><v-toolbar v-if="coverLetterMode" dense color="grey lighten-3" flat>
          <v-icon>mdi-pencil</v-icon>
          <v-toolbar-title>Edit Cover Letter </v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-if="queryMode" dense color="grey lighten-3" flat>
          <v-icon>mdi-magnify</v-icon>
          <v-toolbar-title>Query Cover Letter </v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-if="newCoverLetter" dense color="grey lighten-3" flat>
          <v-icon>mdi-plus</v-icon>
          <v-toolbar-title>Create New Cover Letter</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6 v-if="newCoverLetter">
                <v-autocomplete
                  :items="scheme"
                  v-model="forms.scheme"
                  :label="labels.scheme"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('scheme')"
                  data-vv-name="forms.scheme"
                  :data-vv-as="labels.scheme"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.scheme }}</v-subheader>
                <div class="queryValue" v-for="item in filterSchemeList" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs6 v-if="newCoverLetter">
                <v-autocomplete
                  :items="letterTypeList"
                  v-model="forms.letterType"
                  :label="labels.letterType"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('letterType')"
                  data-vv-name="forms.letterType"
                  :data-vv-as="labels.letterType"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.letterType }}</v-subheader>
                <div class="queryValue" v-for="item in filterLetterTypeList" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="forms.letterText"
                  :readonly="queryMode"
                  :label="labels.letterText"
                  no-resize
                  rows="10"
                  :error-messages="errors.collect('letterText')"
                  data-vv-name="letterText"
                  :data-vv-as="labels.letterText"
                  :maxlength="4000"
                ></v-textarea>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ forms.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ forms.createdDate | formatDate }}</div>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="!newCoverLetter">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ forms.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ forms.modifiedDate | formatDate }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="doClose">Cancel</v-btn>
          <v-btn v-show="!queryMode" color="primary" text @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doDelete">
      <p>Are you sure you want to delete Cover Letter?</p>
      <div class="queryValue">
        Scheme: {{ selectedCvrLtr.scheme }}<br />
        Letter Type: {{ selectedCvrLtr.letterType }}<br />
      </div>
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI } from '@/utils/ajax'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Cancellation Letter',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'cancelLtr' }
        },
        {
          text: 'Payment Status Letter',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'paytStatLtr' }
        }
      ],
      coverLetterReview: false,
      coverLetterMode: false,
      queryMode: false,
      reviewMode: false,
      newCoverLetter: true,
      headers: [{ text: 'Scheme', value: 'scheme' }, { text: 'Letter Type', value: 'letterType' }, TableConst.tableActionHeader],
      labels: {
        scheme: 'Scheme',
        letterType: 'Letter Type',
        letterText: 'Letter Text',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      forms: {
        scheme: '',
        letterType: 'P',
        letterText: '',
        createdBy: '',
        createdDate: '',
        modifiedBy: '',
        modifiedDate: ''
      },
      items: [],
      loading: false,
      scheme: [],
      promptRemove: false,
      letterTypeList: [
        { label: 'D - Disclosure', value: 'D' },
        { label: 'E - Endorsement', value: 'E' },
        { label: 'P - Policy', value: 'P' }
      ],
      selectedCvrLtr: {
        scheme: '',
        letterType: ''
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataList('scheme')
      this.getCoverLetterList()
    },
    getCoverLetterList() {
      const apiURI = this.menu.cvrLtrList
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.items = []
            const { data } = result.data
            if (data) {
              data.map((data) => {
                const convertList = {
                  scheme: data.scheme,
                  letterType: data.letterType
                }
                this.items.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doFetchData(data) {
      this.resetValidator()
      this.resetMessages()
      if (data) {
        this.newCoverLetter = false
        const expand = {
          scheme: data.scheme,
          letterType: data.letterType
        }
        const apiURI = this.menu.getCvrLtr
        if (apiURI) {
          this.$http
            .get(expandURI(apiURI, expand))
            .then((result) => {
              const { data } = result.data
              if (data) {
                this.forms.scheme = data.cvrLtr.scheme
                this.forms.letterType = data.cvrLtr.letterType
                this.forms.letterText = data.cvrLtr.letterText
                this.forms.createdBy = data.createdBy
                this.forms.createdDate = data.createdDate
                this.forms.modifiedBy = data.modifiedBy
                this.forms.modifiedDate = data.modifiedDate
                this.coverLetterReview = true
              }
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.message(data)
                this.fieldMessage(data)
              }
            })
        }
      }
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.forms.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.forms.createdDate = new Date()
      this.forms.modifiedBy = null
      this.forms.modifiedDate = null
      this.newCoverLetter = true
      this.coverLetterReview = true
    },
    doReview(data) {
      this.doFetchData(data)
      this.reviewMode = true
      this.queryMode = false
    },
    doQuery(data) {
      this.doFetchData(data)
      this.queryMode = true
      this.reviewMode = false
    },
    async doPromptRemove(data) {
      this.resetMessages()
      try {
        const expand = {
          scheme: data.scheme,
          letterType: data.letterType
        }
        const apiURI = this.menu.checkDeleteCvrLtr
        await this.$http.get(expandURI(apiURI, expand))
        this.selectedCvrLtr.scheme = data.scheme
        this.selectedCvrLtr.letterType = data.letterType
        this.promptRemove = true
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.fieldMessage(data)
          this.notify(data)
        }
      }
    },
    doDelete() {
      this.resetMessages()
      if (this.selectedCvrLtr) {
        const apiURI = this.menu.deleteCvrLtr
        if (apiURI) {
          const expand = {
            scheme: this.selectedCvrLtr.scheme,
            letterType: this.selectedCvrLtr.letterType
          }
          this.$http
            .delete(expandURI(apiURI, expand))
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.doInit()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doClose() {
      this.resetValidator()
      this.resetMessages()
      this.reviewMode = false
      this.coverLetterReview = false
      this.forms.scheme = ''
      this.forms.letterType = 'P'
      this.forms.letterText = ''
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newCoverLetter) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCreate() {
      const apiURI = this.menu.createCvrLtr
      if (apiURI) {
        this.$http
          .post(apiURI, this.forms)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.doInit()
              this.doClose()
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doUpdate() {
      const apiURI = this.menu.updateCvrLtr
      if (apiURI) {
        this.$http
          .put(apiURI, this.forms)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.doInit()
              this.doClose()
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    }
  },
  mounted() {},
  created() {
    this.doInit()
  },
  computed: {
    menu() {
      return this.$store.state.coverLetterParam.menu
    },
    filterSchemeList() {
      return this.scheme.filter((list) => {
        return list.value === this.forms.scheme
      })
    },
    filterLetterTypeList() {
      return this.letterTypeList.filter((list) => {
        return list.value === this.forms.letterType
      })
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  components: {
    SideFunctionMenu
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>
